import React from 'react';
import {
  IconButton,
  Tooltip,
} from '@mui/material';
import RemoveRedEyeOutlinedIcon from '@mui/icons-material/RemoveRedEyeOutlined';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';

const DatasetList = ({ datasets, onViewClick, onEditClick, onDeleteClick }) => {
  return (
    <table style={{
      borderCollapse: 'separate',
      borderSpacing: 0,
      width: '100%',
      borderRadius: '12px',
      overflow: 'hidden',
      boxShadow: '0 4px 20px 0 rgba(0, 0, 0, 0.1)',
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif'
    }}>
      <thead>
        <tr style={{
          backgroundColor: '#1976d2',
          color: 'white',
          textAlign: 'left'
        }}>
          <th style={{ padding: '16px 24px', fontWeight: 500 }}>#</th>
          <th style={{ padding: '16px 24px', fontWeight: 500 }}>ID</th>
          <th style={{ padding: '16px 24px', fontWeight: 500 }}>Event Name</th>
          <th style={{ padding: '16px 24px', fontWeight: 500 }}>Action</th>
        </tr>
      </thead>
      <tbody>
        {datasets.map((dataset, index) => (
          <tr key={dataset.id} style={{
            backgroundColor: index % 2 === 0 ? '#ffffff' : '#f9f9f9',
            transition: 'background-color 0.2s',
            ':hover': {
              backgroundColor: '#f0f7ff'
            }
          }}>
            <td style={{ padding: '16px 24px', borderBottom: '1px solid #e0e0e0' }}>{index + 1}</td>
            <td style={{ padding: '16px 24px', borderBottom: '1px solid #e0e0e0' }}>{dataset.id}</td>
            <td style={{ padding: '16px 24px', borderBottom: '1px solid #e0e0e0' }}>{dataset.eventName}</td>
            <td style={{ padding: '16px 24px', borderBottom: '1px solid #e0e0e0' }}>
              <Tooltip title="View" arrow>
                <IconButton 
                  onClick={() => onViewClick(dataset.id)}
                  sx={{
                    color: '#1976d2',
                    '&:hover': {
                      backgroundColor: 'rgba(25, 118, 210, 0.08)'
                    }
                  }}
                >
                  <RemoveRedEyeOutlinedIcon />
                </IconButton>
              </Tooltip>
              <Tooltip title="Edit" arrow>
                <IconButton 
                  onClick={() => onEditClick(dataset.id)}
                  sx={{
                    color: '#ed6c02',
                    '&:hover': {
                      backgroundColor: 'rgba(237, 108, 2, 0.08)'
                    }
                  }}
                >
                  <EditOutlinedIcon />
                </IconButton>
              </Tooltip>
              <Tooltip title="Delete" arrow>
                <IconButton 
                  onClick={() => onDeleteClick(dataset.id)}
                  sx={{
                    color: '#d32f2f',
                    '&:hover': {
                      backgroundColor: 'rgba(211, 47, 47, 0.08)'
                    }
                  }}
                >
                  <DeleteOutlineOutlinedIcon />
                </IconButton>
              </Tooltip>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default DatasetList; 